import type { IconProps } from './types';
import './icons.css';

export default function TwoArrows({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      className={`icon icon-two-arrows ${className || ''}`}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
        d="M3.25 7.25h16M20.75 16.75h-16"
      />
      <path
        fill="transparent"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
        d="m7.25 12.75-4 4 4 4M16.75 11.25l4-4-4-4"
      />
    </svg>
  );
}
